import React, { Component } from "react";
import cx from "classnames";
import "./Button.css";

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locked: false
    };
  }

  onClick = async e => {
    const { onClick } = this.props;
    const { locked } = this.state;

    if (onClick && !locked) {
      const res = onClick(e);
      if (res && res.then) {
        this.setState({ locked: true });
        await res;
        this.setState({ locked: false });
      }
    }
  };

  render() {
    const {
      primary,
      info,
      success,
      warning,
      danger,
      transparent,
      white,
      compact,
      disabled,
      onClick,
      ...props
    } = this.props;
    const { locked } = this.state;

    return (
      <button
        className={cx("Button", {
          "Button--Primary": primary,
          "Button--Info": info,
          "Button--Success": success,
          "Button--Warning": warning,
          "Button--Danger": danger,
          "Button--Transparent": transparent,
          "Button--White": white,
          "Button--Compact": compact,
          "Button--Disabled": disabled || locked
        })}
        onClick={this.onClick}
        {...props}
      />
    );
  }
}

export default Button;
